import React from 'react'

const Header = () => {
  return (
    <div>
      <header className="header">
        <div className="navbar navbar-default navbar-fixed-top">
          <div className="container">
            <div className="row">
              <div className="navbar-header page-scroll">
                <a className="navbar-brand page-scroll" href="/">
                  <h4 style={ { color: 'white' } }>Taco paseo compras</h4>
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  )
}


export default Header;